import * as types from '../../../actions/types';

const initialState = {};

export default function vsoko (state = initialState, action) {
  switch (action.type) {
    case types.SET_DASHBOARD_DETAILS_VSOKO:
      return action.payload

    default:
      return state;
  }
}
